import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Config
import { uiConfig } from '../../../../../../conf/predicate';

// Components
import { DeletePredicateConfirmation } from './components/DeletePredicateConfirmation';
import { PredicateChildren } from './components/PredicateChildren';
import { NewPredicateButton } from './components/NewPredicateButton';
import { PredicateEditor } from './components/PredicateEditor';
import { ActionsContainer } from './components/PredicateRowActions';
import { PredicateRootDropZone } from './components/PredicateRootDropZone';

// Context
import { RuleEditorContext } from './context';

// Hooks
import { useCriteriaStoreRootUuid } from '../../../../../state/criteria/hooks/useCriteriaStoreRootUuid';

// Styles
import { ScrollableMixin } from '../../../../../../../common/styles/mixins';

// Util
import { translateUIConfigForAddEdit } from '../../../../../../../common/utility';

const RuleEditorContainerCont = styled.div`
    padding-top: 2.9rem;
`;
const RuleEditorContainer = styled.div`
    ${'' /* padding: 0 1rem 5rem; */}
    padding: 0 1rem;
    margin-left: -1rem;
    margin-right: -1rem;
    position: relative;
    border: 1px solid #c4dbeb;
    border-radius: 0 0 6px 6px;
    border: 2px solid #6c9dcb;
    ${ScrollableMixin};
    max-height: calc(90vh - 18rem);
    background-color: #fcfdff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23cbe5ff' fill-opacity='0.16'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
`;

const RuleEditorHeaderBar = styled.div`
    padding: 0.9rem 15px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 2px;
    right: -1rem;
    left: -1rem;
    align-items: center;
    background: #fff;
    border-bottom: 1px solid #c4dbeb;
    z-index: 2;
    border-radius: 6px 6px 0 0;

    background: #6c9dcb;
    color: #fff;
    top: 0;
    border-bottom: 1px solid #6c9dcb;
`;

const RuleEditorHeader = styled.h4`
    margin: 0;
    font-weight: 600;
    font-size: 1rem;
`;

const NewButtonWrapper = styled.div`
    position: absolute;
    bottom: 10px;
    right: 10px;
    z-index: 1;
`;

export const RuleEditor = ({ criteriaUuid, criteriaId, sessionToken, setEdited }) => {
    const [editing, setEditing] = React.useState(null);
    const [deleting, setDeleting] = React.useState(null);
    const rootUuid = useCriteriaStoreRootUuid();
    const closeEditor = () => {
        setEditing(null);
    };

    return (
        <RuleEditorContext.Provider
            value={{
                editing,
                setEditing,
                deleting,
                setDeleting,
                setEdited,
                criteriaUuid,
                criteriaId
            }}
        >
            <div style={{ position: 'relative' }}>
                <RuleEditorHeaderBar>
                    <RuleEditorHeader>Predicate</RuleEditorHeader>
                    <ActionsContainer>
                        <RuleEditorHeader>Actions</RuleEditorHeader>
                    </ActionsContainer>
                </RuleEditorHeaderBar>
                <RuleEditorContainerCont>
                    <RuleEditorContainer>
                        <div style={{ position: 'relative' }}>
                            <DndProvider backend={HTML5Backend}>
                                <PredicateChildren uuid={criteriaUuid} />
                                <PredicateRootDropZone />
                            </DndProvider>
                        </div>
                    </RuleEditorContainer>
                </RuleEditorContainerCont>
                <NewButtonWrapper>
                    <NewPredicateButton
                        showLabel={false}
                        buttonProps={{ round: true, appearance: 'primary' }}
                        iconSize={24}
                        parentPredicateUuid={rootUuid}
                    />
                </NewButtonWrapper>
            </div>
            {editing && (
                <PredicateEditor
                    formModel={translateUIConfigForAddEdit(uiConfig)}
                    saveDisabled={false}
                    selectedPredicateId={editing}
                    closeDrawer={closeEditor}
                    sessionToken={sessionToken}
                    onMount={typeof uiConfig.onFormMount === 'function' ? uiConfig.onFormMount : undefined}
                    onUpdate={() => setEdited(true)}
                />
            )}
            {deleting ? (
                <DeletePredicateConfirmation
                    predicateUuid={deleting}
                    onDelete={() => {
                        setEdited(true);
                    }}
                    onClose={() => {
                        setDeleting(null);
                    }}
                />
            ) : null}
        </RuleEditorContext.Provider>
    );
};

export default RuleEditor;

RuleEditor.propTypes = {
    criteriaId: PropTypes.string,
    criteriaUuid: PropTypes.string,
    sessionToken: PropTypes.string,
    setEdited: PropTypes.func
};
